let openLinkDirective = {}

const open = (url = '/') => {
    window.open(url, '_blank')
}

const isObject = path => {
    if (typeof path === 'object' && path !== null) {
        return true
    }
    return false
}

const redirect = (path, vnode) => {
    isObject(path)
        ? open(vnode.context.$router.resolve(path).href)
        : open(path)
}

openLinkDirective.install = Vue => {
    Vue.directive('open', {
        bind (el, binding, vnode) {
            el.addEventListener('click', () => {
                redirect(binding.value, vnode)
            })
        },
        unbind (el) {
            el.removeEventListener('click', () => {
                redirect(binding.value)
            })
        }
    })
}

export default openLinkDirective